module.exports = __webpack_public_path__ + "06_mole.380362fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer2/06_mole.png
// module id = fUB7
// module chunks = 0